(function initLocalHelpNavigation() {
  const root = document.querySelector("[data-help-root]");
  if (!root) return;

  const category = root.querySelector("[data-category-filter]");
  const type = root.querySelector("[data-type-filter]");
  const sort = root.querySelector("[data-library-sort]");
  const reset = root.querySelector("[data-library-reset]");
  const categoryButtons = Array.from(root.querySelectorAll("[data-category-choice]"));
  const typeRow = root.querySelector("[data-type-filter-row]");
  const typeChoices = root.querySelector("[data-type-choices]");
  const cards = Array.from(root.querySelectorAll("[data-idea-card]"));
  const detailLinks = Array.from(root.querySelectorAll("[data-detail-link]"));
  const incoming = new URLSearchParams(window.location.search);

  function currentState() {
    const params = new URLSearchParams();
    if (category?.value) params.set("category", category.value);
    if (type?.value) params.set("type", type.value);
    if (sort?.value && sort.value !== "popular") params.set("sort", sort.value);
    return params;
  }

  function renderTypeChoices() {
    if (!typeRow || !typeChoices) return;

    const selectedCategory = category?.value || "";
    typeRow.hidden = !selectedCategory;
    typeChoices.replaceChildren();
    if (!selectedCategory) return;

    const availableTypes = [...new Set(
      cards
        .filter((card) => card.dataset.category === selectedCategory)
        .map((card) => card.dataset.type)
        .filter(Boolean)
    )];

    const choices = [
      { label: "All product types", value: "" },
      ...availableTypes.map((value) => ({ label: value, value }))
    ];

    choices.forEach(({ label, value }) => {
      const button = document.createElement("button");
      button.type = "button";
      button.dataset.typeChoice = value;
      button.textContent = label;
      typeChoices.append(button);
    });
  }

  function updateVisualSelection() {
    const selectedCategory = category?.value || "";
    const selectedType = type?.value || "";

    categoryButtons.forEach((button) => {
      const selected = button.dataset.categoryChoice === selectedCategory;
      button.classList.toggle("is-active", selected);
      button.setAttribute("aria-pressed", String(selected));
    });

    typeChoices?.querySelectorAll("[data-type-choice]").forEach((button) => {
      const selected = button.dataset.typeChoice === selectedType;
      button.classList.toggle("is-active", selected);
      button.setAttribute("aria-pressed", String(selected));
    });
  }

  function updateDetailLinks(params) {
    const query = params.toString();
    const returnUrl = `index.html${query ? `?${query}` : ""}#diy-ideas`;

    detailLinks.forEach((link) => {
      const url = new URL(link.getAttribute("href"), window.location.href);
      url.searchParams.set("return", returnUrl);
      link.setAttribute("href", `${url.pathname.split("/").pop()}${url.search}`);
    });
  }

  function saveState() {
    const params = currentState();
    const query = params.toString();
    const nextUrl = `${window.location.pathname}${query ? `?${query}` : ""}${window.location.hash}`;
    window.history.replaceState(null, "", nextUrl);
    updateVisualSelection();
    updateDetailLinks(params);
  }

  if (incoming.has("category") && category) {
    category.value = incoming.get("category") || "";
    category.dispatchEvent(new Event("change", { bubbles: true }));
  }

  if (incoming.has("type") && type && !type.disabled) {
    type.value = incoming.get("type") || "";
    type.dispatchEvent(new Event("change", { bubbles: true }));
  }

  if (incoming.has("sort") && sort) {
    sort.value = incoming.get("sort") || "popular";
    sort.dispatchEvent(new Event("change", { bubbles: true }));
  }

  renderTypeChoices();
  updateVisualSelection();

  categoryButtons.forEach((button) => {
    button.addEventListener("click", () => {
      if (!category) return;
      category.value = button.dataset.categoryChoice || "";
      category.dispatchEvent(new Event("change", { bubbles: true }));
    });
  });

  typeChoices?.addEventListener("click", (event) => {
    const button = event.target.closest("[data-type-choice]");
    if (!button || !type) return;
    type.value = button.dataset.typeChoice || "";
    type.dispatchEvent(new Event("change", { bubbles: true }));
  });

  category?.addEventListener("change", () => {
    renderTypeChoices();
    updateVisualSelection();
    saveState();
  });
  type?.addEventListener("change", () => {
    updateVisualSelection();
    saveState();
  });
  sort?.addEventListener("change", saveState);
  reset?.addEventListener("click", () => {
    renderTypeChoices();
    updateVisualSelection();
    saveState();
  });

  saveState();
})();
